import { HttpResponse } from '@angular/common/http';
import {
  CSS_CLASSES,
  DEFAULT_EXCEL_FILENAME,
  DOWNLOAD_LINK_TAG,
  EXCEL_FILENAME_HEADER,
  EXCEL_MIME_TYPE,
  FIRST_INDEX
} from './my-working-report.constants';

export class MyWorkingReportBrowserAdapter {
  constructor(
    private pageWindow: Window,
    private pageDocument: Document
  ) {
  }

  public width(): number {
    return this.pageWindow.innerWidth;
  }

  public setGlobalElementsHidden(hidden: boolean): void {
    const container = this.pageDocument.getElementsByClassName(CSS_CLASSES.CONTAINER);
    const navbar = this.pageDocument.getElementsByClassName(CSS_CLASSES.NAVBAR);
    this.toggleClass(container, CSS_CLASSES.HIDE, hidden);
    this.toggleClass(navbar, CSS_CLASSES.HIDE, hidden);
  }

  public downloadExcel(response: HttpResponse<Blob>): void {
    const blob = new Blob([response.body], {type: EXCEL_MIME_TYPE});
    const url = this.pageWindow.URL.createObjectURL(blob);
    const link = this.pageDocument.createElement(DOWNLOAD_LINK_TAG);
    link.href = url;
    link.download = response.headers.get(EXCEL_FILENAME_HEADER) || DEFAULT_EXCEL_FILENAME;
    link.click();
    this.pageWindow.URL.revokeObjectURL(url);
    link.remove();
  }

  public reportError(message: string, error: Object): void {
    const browserConsole = this.pageWindow.console;
    browserConsole.error(message, error);
  }

  private toggleClass(collection: HTMLCollectionOf<Element>, className: string, hidden: boolean): void {
    if (collection.length <= FIRST_INDEX) {
      return;
    }
    if (hidden) {
      collection[FIRST_INDEX].classList.add(className);
    } else {
      collection[FIRST_INDEX].classList.remove(className);
    }
  }
}

export function createMyWorkingReportBrowserAdapter(): MyWorkingReportBrowserAdapter {
  return new MyWorkingReportBrowserAdapter(window, document);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report-browser.adapter.ts